import { PlatformRequestService } from "./PlatformRequestService";
export class PlatformV1RequestService extends PlatformRequestService {
    getParsedToken(response) {
        if (response.includes("ERROR")) {
            throw response;
        }
        let token = response.replace("ApiAccessToken = '", "").replace("'", "");
        if (!token) {
            throw new Error("Token is not available");
        }
        return token;
    }
}
//# sourceMappingURL=PlatformV1RequestService.js.map